(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["bor-facebook-social-plugin"] && !window.DesignMode) return;
  try {
    

(function($) {

      $(function() {

        $(".sbm-form-2").submit(function(e){

          e.preventDefault();

          var $form = $(this),
            name = $form.find('input[name="name"]').val(),
            email = $form.find('input[name="email"]').val(),
            url = $form.attr('action');

          $.post(url, {name:name, email:email},
            function(data) {
              if(data)
              {
                if(data=="Some fields are missing.")
                {
                  $(".nl-submit-status").text("Please fill in your name and email.");
                  $(".nl-submit-status").css("color", "red");
                }
                else if(data=="Check entries.")
                {
                  $(".nl-submit-status").text("Check your entries.");
                  $(".nl-submit-status").css("color", "red");
                }
                else if(data=="Invalid email address.")
                {
                  $(".nl-submit-status").text("Your email address is invalid.");
                  $(".nl-submit-status").css("color", "red");
                }
                else if(data=="Invalid list ID.")
                {
                  $(".nl-submit-status").text("Your list ID is invalid.");
                  $(".nl-submit-status").css("color", "red");
                }
                else if(data=="Already subscribed.")
                {
                  $(".nl-submit-status").text("You're already subscribed!");
                  $(".nl-submit-status").css("color", "red");
                }
                else
                {
                  $(".nl-submit-status").text("You're subscribed!");
                  $(".nl-submit-status").css("color", "green");
                }
              }
              else
              {
                alert("Sorry, unable to subscribe. Please try again later!");
              }
            }
          );
        });

        $(".sbm-form-2").keypress(function(e) {
          if(e.keyCode == 13) {
            e.preventDefault();
            $(this).submit();
          }
        });

        $(".sbm-submit").click(function(e){
          e.preventDefault();
          $(".sbm-form-2").submit();
        });


      });

    }(jQuery));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bor-prediscount-popup"]) return;
  try {
    

if(prediscount_on){
  if (sessionStorage.getItem('prediscount_shown')){

    jQuery.getJSON('/cart.js', function(cart) {

      let cart_total_price = cart.total_price/100;
      
      if(cart_total_price <= prediscount_settings_min){
        sessionStorage.removeItem('prediscount_shown');
      }
    }); 

  } else {
    jQuery.getJSON('/cart.js', function(cart) {

      let cart_total_price = cart.total_price/100;

      if(cart_total_price >= prediscount_settings_min && cart_total_price <= prediscount_settings_max){
        //$('#cartTotalPrice').html(cart.total_price + " " + prediscount_settings_min + " " + prediscount_settings_max);
        $('#prediscountPopup').modal('show');
        sessionStorage.setItem('prediscount_shown', true);
      }
    }); 
  }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-with-filter"] && !window.DesignMode) return;
  try {
    
  $('.filter-category').change(function() {
    var url = $(this).val();
    if (url) {
      window.location = url;
    }
    return false;
  });

  $('.filter-tag').change(function() {
    var url = $(this).val();
    if (url) {
      console.log(url);
      window.location = url;
    }
    return false;
  });

  } catch(e) { console.error(e); }
})();

})();
